const zIndices = {
  hide: -1,
  auto: 'auto',
  base: 0,
  docked: 10,
  sidebar: 500,
  dropdown: 1000,
  sticky: 1100,
  banner: 1200,
  header: 1300,
  overlay: 1400,
  modal: 1500,
  popover: 1600,
  skipLink: 1700,
  toast: 1800,
  tooltip: 1900,
};

export default zIndices;

export type ZIndicesType = typeof zIndices;
